export enum OtpType {
  'bureau' = 'bureau',
  'agreement' = 'agreement'
}
